import React from 'react';
import './StatusButton.css';

/**
 * StatusButton Component
 * 
 * Displays KYC/Sanction status synced from CRM profiles.
 * Supports: cleared, approved, pending, sanctioned, flagged
 * Can be set to readOnly when linked to CRM profile
 */

const STATUS_CONFIG = {
  cleared: { text: 'Cleared', colorClass: 'status-button-cleared' },
  approved: { text: 'Approved', colorClass: 'status-button-approved' },
  pending: { text: 'Pending', colorClass: 'status-button-pending' },
  sanctioned: { text: 'Sanctioned', colorClass: 'status-button-sanctioned' },
  flagged: { text: 'Flagged', colorClass: 'status-button-flagged' },
  check: { text: 'Check!', colorClass: 'status-button-check' }
};

const StatusButton = ({ 
  status = 'pending',
  onChange, 
  label = 'Status',
  disabled = false,
  readOnly = false
}) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  
  const handleClick = () => {
    if (disabled || readOnly) return;
    if (onChange) onChange(status);
  };

  const isDisabled = disabled || readOnly;

  return (
    <div className="status-button-container">
      <label className="status-button-label">{label}</label>
      <button
        type="button"
        className={`status-button ${config.colorClass} ${
          isDisabled ? 'status-button-disabled' : ''
        } ${readOnly ? 'status-button-readonly' : ''}`}
        onClick={handleClick}
        disabled={isDisabled}
        title={readOnly ? 'Linked to CRM profile status' : ''}
      >
        {config.text}
      </button>
    </div>
  );
};

export default StatusButton;

